import React from "react";
import ARAYEH_LOGO from "assets//arayeh.png";
import BANK_LOGO from "assets/cbi.png";
import SHAPARAK_LOGO from "assets/shaparak.png";
import styles from "./footer.module.scss";
import { Col, Row } from "react-bootstrap";
export const Footer = () => {
  return (
    <footer className={styles.footer_container} id="#contact-us">
      <Row>
        <Col md={6} sm={12}>
          <Row>
            <Col md={6} sm={12}>
              <div className="d-flex flex-column gap-3 w-100">
                <h4>ارتباط با ما</h4>
                <span>
                  <h4> آدرس:</h4>
                  <label>
                    استان: تهران، شهرستان : تهران، بخش : مرکزی، شهر: تهران،
                    محله: کاووسیه، خیابان ولیعصر، خیابان نگار، پلاک: 16.0، طبقه:
                    5، واحد: شرقی
                  </label>
                </span>
                <span>
                  <h4> پست الکترونیکی : </h4>
                  <label>info@arayehco.com</label>
                </span>
                <span>
                  <h4> تلفن : </h4> <label>021886772 </label>
                </span>
              </div>
            </Col>

            <Col md={6} sm={12} className="d-none d-md-block">
              <div className="d-flex flex-column gap-3 w-100">
                <h4>Poolban</h4>
                <span>درگاه پرداخت اینترنتی</span>
                <span>تعرفه‌ها</span>
                <span>تسویه</span>
                <span>فرم و لینک پرداخت</span>
                <span>بازگشت وجه</span>
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={6} sm={12}>
          <div className={styles.logo_container}>
            <a
              href="https://hooshmandtechnology.ir/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={ARAYEH_LOGO} width={80} alt="poolban.ir" />
            </a>
            <a href="https://www.shaparak.ir" target="_blank" rel="noreferrer">
              <img src={SHAPARAK_LOGO} width={100} alt="www.shaparak.ir" />
            </a>
            <a href="https://www.cbi.ir/" target="_blank" rel="noreferrer">
              <img src={BANK_LOGO} width={110} alt="www.cbi.ir" />
            </a>
            <a
              rel="noreferrer"
              className="cursor-pointer p-2 lg:p-4 flex items-center justify-center border-complete-200 rounded mr-2"
              target="_blank"
              referrerPolicy="origin"
              href="https://trustseal.enamad.ir/?id=225552&amp;Code=JSMOTPZhkXPSxQ3DQiUP"
            >
              <div>
                <img
                  id="sScdOJOzhFxtcEqkjP7P"
                  referrerPolicy="origin"
                  src="https://Trustseal.eNamad.ir/logo.aspx?id=225552&amp;Code=JSMOTPZhkXPSxQ3DQiUP"
                  alt="نماد اعتماد الکترونیک"
                />
              </div>
            </a>
          </div>
        </Col>
      </Row>
      <hr />
      <div> © تمامی حقوق مالکیت معنوی این وب‌سایت برای پولبان محفوظ است</div>
    </footer>
  );
};
